import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const Timer = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const interval = setInterval(() => {
      const lastActivityTime = localStorage.getItem('loginTime')

      if (lastActivityTime) {
        const currentTime = new Date().getTime();
        const elapsedMinutes = (currentTime - lastActivityTime) / (1000 * 60);

        if (elapsedMinutes >= (2 * 3600)) {
          // Trigger logout
          localStorage.clear();
          navigate('/login');
        }
      }
    }, 1000 * 60); // Check every minute

    return () => clearInterval(interval);
  }, []);

  return null;
};

export default Timer;
